controllers.controller('ChartController', [
    '$q', '$scope', '$state', '$ionicLoading', 'config', 'constants', 'API', 'AssetService', 'LocaleService', 'UserService', 'Utils',
    function ($q, $scope, $state, $ionicLoading, config, Const, API, AssetService, LocaleService, UserService, Utils) {

        LocaleService.wait().then(function (translation) {
            $scope.translation = translation;
        });

        $scope.category = $state.params.category;
        var assetId = $state.params.assetId;
        $scope.asset = AssetService.collection.get({id: parseInt(assetId, 10)});

        $scope.user = UserService.get();

        $scope.chart = {
            ready: false,
            loadstate: 'loading',
            earlyHistory: null //loading,success,fail
        };

        $scope.stopEarlyHistory = false;

        $scope.chart.type = Const.chartTypes[0];
        $scope.chartTypes = Const.chartTypes;

        $scope.chart.range = Const.chartRangeParams[1];
        $scope.chartRangeParams = Const.chartRangeParams;

        $scope.modal = {
            actionText: 'Close',
            state: false,
            back: 'root.app.assets'
        };

        initChart();

        function getHistory() {
            return API.mt4GetChart({
                SymbolID: $scope.asset.id,
                TimeFrame: $scope.chart.range.timeFrame || 1
            });
        }

        function parseHistoryData(data) {
            var chartData = JSON.parse(data.Chart);
            if (chartData && data.status === 1 && chartData.length > 10) {
                return chartData
            }
            return $q.reject();
        }

        function getChart() {
            $scope.loadstate = 'loading';
            return getHistory()
                .then(parseHistoryData)
                .then(function (data) {
                    $scope.chart.data = data;
                    $scope.chart.ready = true;
                    // $scope.loadstate = 'loading';
                })
                .catch(function () {
                    $scope.modal.textTitle = LocaleService.translation.noChartData;
                    $scope.modal.isError = true;
                    $scope.modal.state = true;
                });
        }

        $scope.getEarlyHistory = function (request) {
            var historyRequest = {
                Source: $scope.user.source,
                From: request.from,
                To: request.to,
                SymbolID: $scope.asset.id,
                TimeFrame: $scope.chart.range.timeFrame
            }
            console.log('HISTORY REQUEST', historyRequest);
            return API.mt4GetChartHistory(historyRequest, $scope.user.token)
                .then(parseHistoryData)
                .then(function (data) {
                    // console.log('HISTORY RESPONSE', data);
                    $scope.chart.earlyHistory = {
                        request: request,
                        data: data
                    };
                })
                .catch(function (err) {
                    console.warn('not enough chart history', err);
                    $scope.chart.earlyHistory = {
                        request: request,
                        data: []
                    };
                });
        }

        function initChart() {
            return getChart()
        }

        $scope.changeTimeRange = function (range) {
            $scope.chart.range = range;
            $scope.chart.ready = false;
            return getChart();
        };

        $scope.$watch('chart.loadstate', function (newVal, oldVal) {
            if (newVal !== oldVal && newVal === 'fail') {
                //fail to load chart
                $scope.modal.textTitle = LocaleService.translation.noChartData;
                $scope.modal.isError = true;
                $scope.modal.state = true;
            }
        });

        function clear() {
            $scope.asset = null;
            $scope.chart = null;
            $scope.user = null;
        }

        $scope.$on('$ionicView.afterLeave', clear);
        $scope.$on('$ionicView.unloaded', clear);
        $scope.$on('clear', clear);

    }]);
